/* eslint-disable import/no-unresolved */
import Dashboard from "src/components/Dashboard";
import Header from "src/shared/Header";

function DashboardPage() {
  return (
    <>
      <Header isEnable /> <Dashboard />
    </>
  );
}

export default DashboardPage;
